<template>
  <div class="bottom">
    <div class="bottom_l">
      <div class="bottom_l_t">
        <img
          src="//static.h5.ylmob.com/website/img/bt-wx.jpg"
        />
        <div class="bottom_l_t_r">
          <span>
            微信扫一扫
            <br />关注「本体教育」公众号
          </span>
          <span>获取更多前沿资讯</span>
        </div>
      </div>
      <div style="width:100%;height:0.9984px;background:rgba(255,255,255,0.1);"></div>
      <span>版权所有 © 浙江本体教育科技有限公司</span>
      <div>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">备案号：浙ICP备2021020233号-1</a>
       <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602011857"
          style="display:inline-block;margin-left: 10px;text-decoration: none;"
        >
        <img  src="../../assets/beian.png" style="float:left;"/>
          浙公网安备 33010602011857号 
        </a>
      </div>
    </div>
    <!-- <div class="bottom_m">
      <span>关于本体教育</span>
      <div class="short_line"></div>
      <span>公司简介</span>
      <span>公司文化</span>
      <span>加入我们</span>
    </div>-->
    <div class="bottom_r">
      <span>联系我们</span>
      <div class="short_line"></div>
      <span>客服电话：400-138-9808</span>
      <span>公司邮箱：contact@ylmob.com</span>
      <span>技术咨询 QQ：644934834</span>
    </div>
    
    <div class="bottom_r" style="margin-left: 0.260416rem;">
      <span>商务合作微信</span>
      <div class="short_line"></div>
      <span><img src="../../assets/webwxgetmsgimg.png" style="width: 0.390625rem;height: 0.390625rem;"/></span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
<style scoped>
.bottom {
  width: 100%;
  height: 1.5625rem;
  background: rgba(56, 67, 87, 1);
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom_l {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 1.0313rem;
}
.bottom_l_t {
  display: flex;
  align-items: center;
  margin-bottom: 0.2083rem;
}
.bottom_l_t img {
  width: 0.625rem;
  height: 0.625rem;
  margin-right: 0.1354rem;
}
.bottom_l_t_r {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.bottom_l_t_r span:nth-child(2) {
  font-size: 0.0938rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.0938rem;
}
.bottom_l_t_r span:nth-child(1) {
  font-size: 0.0729rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  line-height: 0.0929rem;
  text-align: left;
  margin-bottom: 0.052083rem;
}
.bottom_l > span {
  font-size: 0.0625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  line-height: 0.0938rem;
  margin-top: 0.1563rem;
}
.bottom_m {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 1.0938rem;
}
.bottom_m span {
  font-size: 0.0729rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  line-height: 0.0729rem;
  margin-bottom: 0.0781rem;
}
.bottom_m span:first-child {
  font-size: 0.0938rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.0938rem;
  margin-bottom: 0.1042rem;
  margin-top: 0.3125rem;
}
.short_line {
  width: 0.1563rem;
  height: 0.0104rem;
  background: rgba(255, 255, 255, 1);
  margin-bottom: 0.1563rem;
}
.bottom_r {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
}
.bottom_r span {
  font-size: 0.0729rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
  line-height: 0.0729rem;
  margin-bottom: 0.0781rem;
}
.bottom_r span:first-child {
  font-size: 0.0938rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 0.0938rem;
  margin-bottom: 0.1042rem;
  margin-top: 0.3125rem;
}
a {
  text-decoration: none;
  font-size: 0.0625rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}
</style>